import { useDynamoDbUserContext } from 'contexts/DynamoDbUserContext'
import { useTranslate } from 'hooks/translation/use-translation'

const useGetCurrentUserCurrency = () => {
  const { lang } = useTranslate('common')
  const { dynamoDbUser } = useDynamoDbUserContext()

  let currency = lang.includes('-hk') ? 'HKD' : 'SGD'
  if (dynamoDbUser?.info.currency) {
    currency = dynamoDbUser.info.currency
  }

  return currency
}

export default useGetCurrentUserCurrency
